var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1950,
    height: 2216,
    viewBox: "0 0 1950 2216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1284.92 1882.2C1362.85 1746.83 1384.09 1586.01 1343.99 1434.96C1303.89 1283.92 1205.72 1154.97 1070.99 1076.39L1327.36 634C1423.77 689.299 1508.31 763.192 1576.09 851.417C1643.88 939.641 1693.58 1040.45 1722.33 1148.03C1751.08 1255.62 1758.3 1367.84 1743.58 1478.24C1728.86 1588.63 1692.49 1695.01 1636.58 1791.24C1523.27 1986.24 1337.71 2128.43 1120.33 2186.85C902.946 2245.26 671.353 2215.16 476 2103.11L479.167 2097.64L480.428 2098.37C547.405 2137.15 621.343 2162.32 698.021 2172.44C774.698 2182.57 852.613 2177.45 927.317 2157.37C1002.02 2137.3 1072.05 2102.67 1133.41 2055.45C1194.76 2008.24 1246.25 1949.36 1284.92 1882.2V1882.2Z",
    fill: "#E0E0E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M573.225 735.431C586.378 891.071 660.617 1035.31 779.677 1136.54C898.736 1237.77 1052.9 1287.73 1208.4 1275.48L1250 1785.08C1139.27 1794.62 1027.69 1782.11 921.697 1748.28C815.705 1714.45 717.397 1659.96 632.444 1587.97C547.491 1515.97 477.574 1427.89 426.725 1328.8C375.875 1229.72 345.1 1121.59 336.175 1010.65C318.089 785.848 389.464 563.236 534.749 391.308C680.034 219.38 887.458 112.066 1111.84 92.7439L1112.35 99.0431L1110.9 99.1645C1033.77 105.491 958.672 126.967 889.906 162.367C821.14 197.767 760.049 246.396 710.12 305.479C660.192 364.562 622.405 432.942 598.917 506.713C575.428 580.485 566.698 658.203 573.225 735.431V735.431Z",
    fill: "#E0E0E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBackground);
export default __webpack_public_path__ + "static/media/logo_background.f32368a20935c6185e9c8a0514bc261d.svg";
export { ForwardRef as ReactComponent };